import { formatDistanceWithoutUnit } from './format-distance-without-unit';

export function formatDistanceWithUnit(meters: number): string {
  return `${formatDistanceWithoutUnit(meters)}\u00A0KM`;
}
